/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateFormAuditDto } from '../models';
/**
 * FormAuditApi - axios parameter creator
 * @export
 */
export const FormAuditApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateFormAuditDto} createFormAuditDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formAuditControllerCreateFormAudit: async (createFormAuditDto: CreateFormAuditDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFormAuditDto' is not null or undefined
            assertParamExists('formAuditControllerCreateFormAudit', 'createFormAuditDto', createFormAuditDto)
            const localVarPath = `/api/form-audit/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFormAuditDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formAuditControllerCreateSuppliersFormAudit: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/form-audit/create/suppliers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormAuditApi - functional programming interface
 * @export
 */
export const FormAuditApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FormAuditApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateFormAuditDto} createFormAuditDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formAuditControllerCreateFormAudit(createFormAuditDto: CreateFormAuditDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formAuditControllerCreateFormAudit(createFormAuditDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormAuditApi.formAuditControllerCreateFormAudit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formAuditControllerCreateSuppliersFormAudit(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formAuditControllerCreateSuppliersFormAudit(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormAuditApi.formAuditControllerCreateSuppliersFormAudit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FormAuditApi - factory interface
 * @export
 */
export const FormAuditApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FormAuditApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateFormAuditDto} createFormAuditDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formAuditControllerCreateFormAudit(createFormAuditDto: CreateFormAuditDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.formAuditControllerCreateFormAudit(createFormAuditDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formAuditControllerCreateSuppliersFormAudit(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.formAuditControllerCreateSuppliersFormAudit(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FormAuditApi - object-oriented interface
 * @export
 * @class FormAuditApi
 * @extends {BaseAPI}
 */
export class FormAuditApi extends BaseAPI {
    /**
     * 
     * @param {CreateFormAuditDto} createFormAuditDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormAuditApi
     */
    public formAuditControllerCreateFormAudit(createFormAuditDto: CreateFormAuditDto, options?: RawAxiosRequestConfig) {
        return FormAuditApiFp(this.configuration).formAuditControllerCreateFormAudit(createFormAuditDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormAuditApi
     */
    public formAuditControllerCreateSuppliersFormAudit(options?: RawAxiosRequestConfig) {
        return FormAuditApiFp(this.configuration).formAuditControllerCreateSuppliersFormAudit(options).then((request) => request(this.axios, this.basePath));
    }
}

